import React from "react";
import { Modal, Select, Radio, InputNumber, TreeSelect } from "antd";
const { TreeNode } = TreeSelect;
const { Option } = Select;

export const AddTransactionRules = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  banks,
  categories,
}) => {
  return (
    <div>
      {" "}
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">{title}</h3>
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "25rem",
            overflow: "scroll",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Rule Name <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Rule Name"
              name="ruleName"
              value={data && data.ruleName}
              id="ruleName"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Apply to Bank Account</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={data && data.appliedTo}
              onChange={(value, id) => {
                handleChange("appliedTo", value);
              }}
            >
            <Option value={"all"}>All</Option>
              {banks &&
                banks.map((item, index) => (
                  <Option key={index} value={item.accountTitle}>
                    {item.accountTitle}
                  </Option>
                ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Money in/Out<span style={{ color: "red" }}>*</span></h3>

          <Radio.Group
            buttonStyle="solid"
            name="moneyCondition"
            value={data && data.moneyCondition}
            onChange={(e) => {
              handleChange(e.target.name, e.target.value);
            }}
          >
            {["Money In", "Money Out","Both"].map((value, vindex) => (
              <Radio.Button key={vindex} value={value}>
                {value}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Name Condition</h3>
            <Radio.Group
              buttonStyle="solid"
              name="nameCondition"
              value={data && data.nameCondition && data.nameCondition.charAt(0).toUpperCase() + data.nameCondition.slice(1).toLowerCase()}
              onChange={(e) => {
                handleChange(e.target.name, (e.target.value).toLowerCase());
              }}
            >
              {["Contain", "Exact"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
         
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Name to Match</h3>
            <input
              className="roleInput"
              placeholder="Name to Match"
              name="nameToMatch"
              value={data && data.nameToMatch}
              id="nameToMatch"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Amount Condition</h3>
            <Radio.Group
              buttonStyle="solid"
              name="amountCondition"
              value={data && data.amountCondition && data.amountCondition.charAt(0).toUpperCase() + data.amountCondition.slice(1).toLowerCase()}
              onChange={(e) => {
                handleChange(e.target.name, (e.target.value).toLowerCase());
              }}
            >
              {["Greater", "Equal", "Lesser", "Between"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Amount to Match</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value && `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount"
                name="amountToMatch"
                value={data && data.amountToMatch}
                id="amountToMatch"
                onChange={(value) => {
                  handleChange("amountToMatch", value);
                }}
              />
            </div>
          </div>
          {data && data.amountCondition && data.amountCondition.toLowerCase() === "between" &&
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Amount Between</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value && `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount"
                name="amountToMatch2"
                value={data && data.amountToMatch2}
                id="amountToMatch2"
                onChange={(value) => {
                  handleChange("amountToMatch2", value);
                }}
              />
            </div>
          </div>
            }
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Change Name To</h3>
            <input
              className="roleInput"
              placeholder="Change Name To"
              name="changeNameTo"
              value={data && data.changeNameTo}
              id="changeNameTo"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Category</h3>
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Choose Category"
              allowClear
              // treeDefaultExpandAll
              value={data && data.category}
              onChange={(value, label, extra) => {
                const selectedNode = extra.triggerNode;
                const parentNode = selectedNode && selectedNode.props.label;
                const selectedCategory = parentNode
                  ? `${value}-${parentNode}`
                  : value;
                console.log("selectedCategory", selectedCategory);
                handleChange("category", selectedCategory);
              }}
            >
              {categories &&
                categories.map((category) => {
                  let parentLabel = category.categoryName;
                  return (
                    <TreeNode
                      key={category.id}
                      value={category.categoryName}
                      title={category.categoryName}
                    >
                      {category.subCategories.map((subCategory, index) => (
                        <TreeNode
                          key={`${category.id}-${index}`}
                          value={subCategory.name}
                          title={subCategory.name}
                          label={parentLabel}
                        />
                      ))}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Change Notes</h3>
            <input
              className="roleInput"
              placeholder="Notes"
              name="changeNotesTo"
              value={data && data.changeNotesTo}
              id="note"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          {/* <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Priority</h3>
            <input
              className="roleInput"
              placeholder="Priority"
              name="priority"
              value={data && data.priority}
              id="priority"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div> */}
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Apply on <span style={{ color: "red" }}>*</span></h3>
            <Radio.Group
              buttonStyle="solid"
              name="applyOn"
              value={data && data.applyOn && data.applyOn.charAt(0).toUpperCase() + data.applyOn.slice(1).toLowerCase()}
              onChange={(e) => {
                handleChange(e.target.name, (e.target.value).toLowerCase());
              }}
            >
              {["All", "Future", "Past"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.ruleName || !data.applyOn || !data.moneyCondition}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
